<div class="dashboard-content" [ngClass]="{'warning-content':showWarning}">
  <router-outlet></router-outlet>

  <!-- ✅ overlay ONLY for this dashboard -->
  <div class="overlay" *ngIf="showWarning">
    <!-- <div class="pulse-ring"></div> -->

    <div class="paywall-card">

      <div class="icon-badge">
        <span class="material-icons">lock_outline</span>
      </div>

      <h2>Account Paused</h2>
      <div class="status-badge">
        Billing Overdue
      </div>
      <p class="description">
        It looks like your subscription has expired or a payment was missed.
        To keep your college dashboard running smoothly and maintain access to student records,
        please settle your outstanding invoices. You can only access the Dashboard, Subscription & Invoicing pages
      </p>

      <div class="info-box">
        <strong>Pro Tip:</strong> Add More than one <b>Payment Method</b> in your subscription page to prevent
        future service interruptions.
      </div>

      <div class="action-group">
        <a routerLink="/college-admin-dashboard/invoices" class="btn-primary">
          View & Pay Invoices
        </a>
        <a routerLink="/college-admin-dashboard/subscription" class="btn-underline">
          View Subscription
        </a>
        <!-- <button class="btn-secondary">Contact Support</button> -->
      </div>
    </div>
  </div>


</div>